import {
    GET_POLLEN_BY_LATLON_FULFILLED,
    GET_POLLEN_BY_LATLON_REJECTED
} from '../actions/pollenActions.js';

const initialState = {

};

export function pollen(state = initialState, action)
{
    switch (action.type)
    {
        case GET_POLLEN_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                pollen: action.payload,
                lastError: {}
            };
        }

        case GET_POLLEN_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                pollen: {},
                lastError: action.payload
            };
        }
    }

    return state;
}
